export enum ContentWidth {
  WINDOW_WIDTH = 0,
  CONTENT_WIDTH = 1,
  TEXT_WIDTH = 2,
}
